import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi =
  ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents/{agentId}']['DELETE'];
type Input = ThisApi['params'];

const deleteQuestionnaireAgent = async ({
  questionnaireTemplateId,
  creatorId,
  agentId,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(
    '/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents/{agentId}',
    { agentId, creatorId, questionnaireTemplateId },
  );

  const data = await formsBackendClient.delete(path);
  return data.data;
};

export default deleteQuestionnaireAgent;
